











































































































import { EngagementTypeComponentEnum } from '@empathybroker/tsclient-stats/dist/enums/engagement/engagement-type-component.enum';
import { StatsReportsIdsEnum } from '@empathybroker/tsclient-stats/dist/enums/stats-reports-ids.enum';
import { SeasonalProductsData } from '@empathybroker/tsclient-stats/dist/models/seasonal/products/seasonal-products-data';
import { SeasonalQueriesData } from '@empathybroker/tsclient-stats/dist/models/seasonal/queries/seasonal-queries-data';
import { StatsResponse } from '@empathybroker/tsclient-stats/dist/models/stats-response';

import VueHtml2pdf from 'vue-html2pdf';

import { mapGetters } from 'vuex';

import { capitalizeSentence } from '../filters';

import { InsightsMixin } from '../mixins';

import { ICarouselExtraText, ICarouselSlide } from '../models';

import { CONFIG_CONSTS } from '../store/config/config.consts';

import EpbButton from './button.component.vue';
import Carousel from './carousel.component.vue';
import { UiIconButton } from './keen-ui';
import Modal from './modal.component.vue';

export enum Action {
  PREVIOUS = 'previous',
  NEXT = 'next'
}

export interface Data {
  queryCount: string;
  queryComparativePct: string;
  queryComparativePctPositive: boolean;
  successCountPct: string;
  successComparativePct: string;
  successComparativePctPositive: boolean;
  topQueries: string[];
  topProducts: string[];
}

export interface TopProduct {
  title: string;
  interactionCount: number;
}

export enum SlidesEnum {
  INTRO_0 = 'intro_0',
  INTRO_1 = 'intro_1',
  TOTAL_SEARCH = 'total_search',
  TOP_QUERIES_0 = 'top_queries_0',
  TOP_QUERIES_1 = 'top_queries_1',
  TOP_PRODUCTS_0 = 'top_products_0',
  TOP_PRODUCTS_1 = 'top_products_1',
  TOP_PRODUCTS_2 = 'top_products_2',
  OUTRO_0 = 'outro_0',
  OUTRO_1 = 'outro_1'
}

export default {
  name: 'yearly-summary-modal',
  mixins: [
    InsightsMixin
  ],
  components: {
    Modal,
    Carousel,
    EpbButton,
    UiIconButton,
    VueHtml2pdf
  },
  computed: {
    ...mapGetters(CONFIG_CONSTS.moduleName, {
      instanceConfig: CONFIG_CONSTS.getters.currentInstance
    }),
    isFirstSlide: function (): boolean {
      return this.activeSlideIndex === 0;
    },
    isLastSlide: function (): boolean {
      return this.activeSlideIndex === this.slides.length - 1;
    },
    instancePrettyName: function (): string {
      return this.instanceConfig.instanceId || capitalizeSentence(this.instanceConfig.id);
    }
  },
  data: function (): Record<string, any> {
    return {
      baseClass: 'epb-yearly-summary',
      icon: require(`../assets/media/image/yearly-summary/candy_icon.svg`),
      slides: [],
      activeSlideIndex: 0,
      creatingPdf: false,
      downloadWidth: 800,
      messages: this.$epb.messages.yearlySummary,
      Action
    };
  },
  methods: {
    onSlideUpdated: function (slideIndex: number): void {
      this.activeSlideIndex = slideIndex;
      this.$emit('tag', EngagementTypeComponentEnum.SLIDER);
    },
    getTextClass: function (activeSlide: ICarouselSlide, item: ICarouselExtraText, i: number): (string | Record<string, boolean>)[] {
      return [
        `${ this.baseClass }__text`,
        `${ this.baseClass }__text--${ activeSlide.title }`,
        `${ this.baseClass }__text--${ activeSlide.title }-${ i }`, {
          [`${ this.baseClass }__text--${ activeSlide.title }-${ i }-${ item.textClass }`]: !!item.textClass
        }
      ];
    },
    getModalTextStylePosition: function (activeSlide: ICarouselSlide, item: ICarouselExtraText,
      slideIndex: number): { position: string, left: string, top: string } {

      const styles = {
        [SlidesEnum.INTRO_0]: () => [
          [145, 193]
        ],
        [SlidesEnum.TOTAL_SEARCH]: () => [
          [215, 178],
          [215, 171],
          [168, 356],
          [166, 359],
          [186, 20]
        ],
        [SlidesEnum.TOP_QUERIES_0]: () => [
          [102, 428]
        ],
        [SlidesEnum.TOP_QUERIES_1]: () => [
          [146, 65],
          [101, 225],
          [-4, 379],
          [-71, 517]
        ],
        [SlidesEnum.TOP_PRODUCTS_1]: () => [
          [190, 136],
          [190, 136],
          [190, 136],
          [77, 430],
          [77, 430],
          [77, 430]
        ],
        [SlidesEnum.TOP_PRODUCTS_2]: () => [
          [182, 65],
          [182, 65],
          [182, 65],
          [67, 273],
          [67, 273],
          [67, 273],
          [-48, 480],
          [-48, 480],
          [-48, 480]
        ]
      };

      const relativePosition = styles[activeSlide.title]()[slideIndex];
      return {
        position: 'relative',
        top: `${ relativePosition[0] }px`,
        left: `${ relativePosition[1] }px`
      };
    },
    getPdfTextStylePosition: function (activeSlide: ICarouselSlide, item: ICarouselExtraText,
      slideIndex: number): { position: string, left: string, top: string } {
      const styles = {
        [SlidesEnum.INTRO_0]: () => [
          [161, 214]
        ],
        [SlidesEnum.TOTAL_SEARCH]: () => [
          [1354, 198],
          [1397, 197],
          [1364, 396],
          [1407, 403],
          [1441, 27]
        ],
        [SlidesEnum.TOP_QUERIES_0]: () => [
          [1787, 476]
        ],
        [SlidesEnum.TOP_QUERIES_1]: () => [
          [2393, 72],
          [2428, 250],
          [2396, 421],
          [2406, 574]
        ],
        [SlidesEnum.TOP_PRODUCTS_1]: () => [
          [3563, 151],
          [3589, 151],
          [3608, 151],
          [3563, 484],
          [3589, 484],
          [3608, 484]
        ],
        [SlidesEnum.TOP_PRODUCTS_2]: () => [
          [4121, 72],
          [4147, 72],
          [4166, 72],
          [4121, 303],
          [4147, 303],
          [4166, 303],
          [4121, 533],
          [4147, 533],
          [4166, 533]
        ]
      };

      const absolutePosition = styles[activeSlide.title]()[slideIndex];
      return {
        position: 'absolute',
        top: `${ absolutePosition[0] }px`,
        left: `${ absolutePosition[1] }px`
      };
    },
    fetchData: async function (): Promise<Data> {
      const params = {
        startDate: null,
        endDate: null,
        eventName: 'year2022',
        rows: 5
      };
      const reportResponses = await Promise.all([
        this.fetchStatsReport({
          id: StatsReportsIdsEnum.SEASONAL_SEARCH,
          params: {
            ...params,
            eventName: 'year2021'
          }
        }),
        this.fetchStatsReport({
          id: StatsReportsIdsEnum.SEASONAL_SEARCH,
          params
        }),
        this.fetchStatsReport({
          id: StatsReportsIdsEnum.SEASONAL_QUERIES,
          params
        }),
        this.fetchStatsReport({
          id: StatsReportsIdsEnum.SEASONAL_PRODUCTS,
          params
        })
      ]);
      const [previousSearchData, searchData, queriesData, productsData] = reportResponses.map((response: StatsResponse) => response.data);
      return {
        queryCount: this.prettyValue(searchData.queryCount),
        queryComparativePct: !!previousSearchData.queryCount ? this.prettyValue(
          this.getIncrementPct(searchData.queryCount, previousSearchData.queryCount), true, true) : '',
        queryComparativePctPositive: searchData.queryCount > previousSearchData.queryCount,
        successCountPct: this.prettyValue(searchData.successCountPct, true),
        successComparativePct: !!previousSearchData.successCountPct ? this.prettyValue(
          this.getIncrementPct(searchData.successCountPct, previousSearchData.successCountPct), true, true) : '',
        successComparativePctPositive: searchData.successCountPct > previousSearchData.successCountPct,
        topQueries: queriesData.map((item: SeasonalQueriesData) => this.prettyText(item.query)),
        topProducts: productsData.map((item: SeasonalProductsData) => {
          return { title: this.prettyText(item.title), interactionCount: (item.clickCount + item.add2cartCount) };
        }).sort((product1: TopProduct, product2: TopProduct) => product2.interactionCount - product1.interactionCount)
          .reduce((list: string[], product: TopProduct) => {
            return [...list, this.prettyValue(product.interactionCount), this.messages.topProducts.actions, product.title];
          }, [])
      };
    },
    prettyValue: function (value: number, isPct = false, isMandatory = false): string {
      let formattedValue = this.$epb.utils.formatNumber(value, { maximumFractionDigits: 2 }, true, false);
      if (isPct) {
        formattedValue = `${ formattedValue }%`;
      }
      if (isMandatory) {
        formattedValue = `${ formattedValue }*`;
      }
      return formattedValue;
    },
    getIncrementPct: function (value1: number, value2: number): number {
      return (value1 - value2) / value2 * 100;
    },
    prettyText: function (text: string): string {
      try {
        return decodeURIComponent(text);
      } catch (e) {
        return text;
      }
    },
    goToSlide: function (action: Action): void {
      const carousel = this.$refs.carousel;
      const slideIndex = {
        [Action.PREVIOUS]: carousel.previousSlideIndex,
        [Action.NEXT]: carousel.nextSlideIndex
      }[action];
      carousel.handleSlideClick(slideIndex);
    },
    generatePdf: function (): void {
      this.$emit('tag', EngagementTypeComponentEnum.DOWNLOAD);
      this.creatingPdf = true;
      this.$refs.html2Pdf.generatePdf();
    },
    onProgressPdf: function (progress): void {
      if (progress === 100) {
        this.creatingPdf = false;
      }
    },
    buildSlides: function (): ICarouselSlide[] {
      return Object.values(SlidesEnum).map((slide: SlidesEnum) => ({
        imageUrl: require(`../assets/media/image/yearly-summary/${ slide }.svg`),
        title: slide,
        active: false,
        extraTexts: this.getSlideTexts(slide)
      }));
    },
    getSlideTexts: function (slide: SlidesEnum): ICarouselExtraText[] {
      const texts = {
        [SlidesEnum.INTRO_0]: () => [
          {
            text: this.instancePrettyName
          }
        ],
        [SlidesEnum.TOTAL_SEARCH]: () => [
          { text: this.data.queryCount, textClass: !this.data.queryComparativePct ? 'centered' : '' },
          this.createTextObject(this.data.queryComparativePct, 'arrowdownward', this.data.queryComparativePctPositive),
          { text: this.data.successCountPct, textClass: !this.data.queryComparativePct ? 'centered' : '' },
          this.createTextObject(this.data.successComparativePct, 'arrowdownward', this.data.successComparativePctPositive),
          { text: this.data.queryComparativePct ? this.messages.comparedLastYear : '' }
        ],
        [SlidesEnum.TOP_QUERIES_0]: () => this.data.topQueries.slice(0, 1).map((query: string) => {
          return { text: query };
        }),
        [SlidesEnum.TOP_QUERIES_1]: () => this.data.topQueries.slice(1).map((query: string) => {
          return { text: query };
        }),
        [SlidesEnum.TOP_PRODUCTS_1]: () => this.data.topProducts.slice(0, 6).map((product: string) => {
          return { text: product };
        }),
        [SlidesEnum.TOP_PRODUCTS_2]: () => this.data.topProducts.slice(6).map((product: string) => {
          return { text: product };
        }),
        default: () => []
      };
      return (texts[slide] || texts.default)();
    },
    createTextObject: function (text: string, icon?: string, increase?: boolean, textClass?: string): ICarouselExtraText {
      return {
        text,
        textClass,
        icon,
        iconClass: this.createIconClass(increase)
      };
    },
    createIconClass: function (increase: boolean): (string | Record<string, boolean>)[] {
      return [
        `${ this.baseClass }__icon eicon`,
        {
          [`${ this.baseClass }__icon--increase`]: increase
        }
      ];
    }
  },
  watch: {
    data: {
      handler: function (_data: Data): void {
        this.slides = this.buildSlides();
      },
      deep: true
    }
  }
};

